export const PoDetailsSupplyWalkContainer = (props: {
  id: string;
  skus: string[];
}) => {
  return null;
};
